import { Card, Tabs } from 'antd'
import { createContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { type Course } from '~/types/course'
import PostEvent from './PostEvent'
import PreEvent from './PreEvent'

const tabItems = [
  {
    key: 'pre-event',
    label: 'Pre-event',
    children: <PreEvent />
  },
  {
    key: 'post-event',
    label: 'Post-event',
    children: <PostEvent />
  }
]

export const CourseContext = createContext<Course | undefined>(undefined)

const EmailTemplates = function ({ course }: { course: any }) {
  const [selectedTab, setSelectedTab] = useState('pre-event')
  const { id } = useParams()

  let title = 'Email templates'
  if (id != null) {
    title = ''
  }

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title={title}
        extra={[
        ]}
      />
      <Card>
        <CourseContext.Provider value={course}>
          <Tabs activeKey={selectedTab} items={tabItems} onChange={key => { setSelectedTab(key) }} />
        </CourseContext.Provider>
      </Card>
    </>
  )
}

export default EmailTemplates
